module.exports = __webpack_public_path__ + "img/Button-kosik-2021-12.9cd79c87.png";